import { app } from '../../../../../../app';
import { resolve } from '../../../../../../init/store';

app.service('SharedFolderAddCSAModal', modal);

/** @ngInject */
function modal($uibModal) {
    return (isAuthenticator, sharedFolder, items) => {
        return $uibModal.open({
            component: 'companySharingCenterSharedFoldersAddCSA',
            resolve: {
                isAuthenticator: () => isAuthenticator,
                sharedFolder: () => sharedFolder,
                items: () => items,
                serviceAccounts
            },
        }).result;

        /** @ngInject */
        function serviceAccounts(SharedAccountsService, $filter) {
            let ids = getCSAIds();
            return SharedAccountsService
                .getAllByCompany({companyId: resolve.companyId}, {}).$promise
                .then(accounts => $filter('orderBy')(accounts, 'publicService.serviceName'))
                .then(accounts => accounts.map((account) => ({...account, serviceDisplayName: serviceDisplayName(account)})))
                .then(accounts => accounts.filter(account => {
                    let alreadyAdded = ids.includes(account.id);
                    let typeAvailable = isAuthenticator ? account.enabled2fa : !account.enabled2fa;
                    return !alreadyAdded && typeAvailable;
                }))
        }

        function getCSAIds() {
            let ids = [];
            items.forEach((item) => {
                if(item.corporateServiceAccount != null) {
                    ids.push(item.corporateServiceAccount.id);
                }
            });
            return ids;
        }

        function serviceDisplayName(account) {
            let displayName = '';
            if (account.publicService.slug != 'other' || !account.customServiceName) {
                displayName = account.publicService.serviceName;
            } else if (account.publicService.slug == 'other'){
                displayName = account.customServiceName;
            }
            return displayName;
        }
    };
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-folders/manage/add-csa/shared-folder-add-csa.modal.js